<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc" title="Contents">
<h1 class="toc_head"><span epub:type="pagebreak" id="page_9" title="9">TABLE OF CONTENTS</span></h1>
<p class="toc_fm" id="rsec1"><a href="#/text/Introduction#sec1">Introduction</a></p>
<p class="toc_ts" id="rsec2"><span href="#/text/Chapter01#sec2" title="Link target outside of Sample">Chapter 1: Pathologizing Protest</span></p>
<p class="toc_ch" id="rsec3"><span href="#/text/Chapter02#sec3" title="Link target outside of Sample">Chapter 2: Americanitis</span></p>
<p class="toc_ch" id="rsec4"><span href="#/text/Chapter03#sec4" title="Link target outside of Sample">Chapter 3: On the Borderlines</span></p>
<p class="toc_ch" id="rsec5"><span href="#/text/Chapter04#sec5" title="Link target outside of Sample">Chapter 4: “They Call Us Queer, You Call Us Sick”</span></p>
<p class="toc_ch" id="rsec6"><span href="#/text/Chapter05#sec6" title="Link target outside of Sample">Chapter 5: No Peace</span></p>
<p class="toc_ch" id="rsec7"><span href="#/text/Chapter06#sec7" title="Link target outside of Sample">Chapter 6: Tipping the Scales</span></p>
<p class="toc_ts" id="rsec8"><span href="#/text/Conclusion#sec8" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc_ch" id="rsec9"><span href="#/text/Acknowledgments#sec9" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc_ch" id="rsec10"><span href="#/text/Notes#sec10" title="Link target outside of Sample">Notes<span epub:type="pagebreak" id="page_10" title="10"></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?5145eb40